module.exports = __webpack_public_path__ + "static/media/Burgers.0eef139f.png";